export default __webpack_public_path__ + "static/media/img2.64d5686f.svg";